export const home = '/page/home'
export const course = '/page/course'
export const service = '/service'
export const cooperative = '/page/cooperative'
export const leaveConditions = '/page/leave_conditions'
export const enrollment = '/page/enrollment'
export const register = '/page/how_to_register'
export const institute = '/institute'
export const question = '/page/question'
export const grade = 'page/table_gpa'
export const meaning = 'page/table_grade'
export const retry = 'page/table_retry'
export const contract = 'institute/branch_contract'
